/**
 * @generated SignedSource<<90e1499508d9a481b7541d70b15282fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionHeaderSectionContentfulRelayFragment$data = {
  readonly collectionNameExternal: string | null | undefined;
  readonly oneLinerHeadline: string | null | undefined;
  readonly " $fragmentType": "collectionHeaderSectionContentfulRelayFragment";
};
export type collectionHeaderSectionContentfulRelayFragment$key = {
  readonly " $data"?: collectionHeaderSectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionHeaderSectionContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionHeaderSectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collectionNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oneLinerHeadline",
      "storageKey": null
    }
  ],
  "type": "TemplateCollection",
  "abstractKey": null
};

(node as any).hash = "2db096abc2188a39c11adfc4c3107e1b";

export default node;
